import { Check, HourglassBottom, Phone, WhereToVote } from "@mui/icons-material";

export const EVENT_STAFF_DATA_ICONS = {
  "On Roster": <Check color="success" fontSize="medium" />,
  "On Premise": <WhereToVote fontSize="medium" sx={{ color: "#FB8C00" }} />,
  Late: <HourglassBottom color="error" fontSize="medium" />,
  "Mobile User": <Phone fontSize="medium" sx={{ color: "#8935F4" }} />,
};
